import React from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

type Props = {
    startDate?: Date | null;
    endDate?: Date | null;
    date?: Date | null;
    minDate?: Date | null;
    maxDate?: Date | null;
    onChange: (date: any) => void;
    placeholder?: string;
    selectsEnd?: boolean
    selectsRange?: boolean;
    selectsStart?: boolean
    classNames?: string
}

export default function CustomDatePicker(props: Props) {  
    return (
        <DatePicker
            className={`calendar-input ${props.classNames}`}
            selected={props.date}
            placeholderText={props.placeholder}
            onChange={(date) => props.onChange(date!)}
            startDate={props.startDate}
            minDate={props.minDate}
            maxDate={props.maxDate}
            endDate={props.endDate}
            selectsRange={props.selectsRange}
            selectsEnd={props.selectsEnd}
            selectsStart={props.selectsStart}
        />
    );
}